"use client";

import { useRouter } from "next/navigation";
import { Button } from "@/components/ui/button";
import { Home, ArrowLeft } from "lucide-react";
import Image from "next/image";
import { useI18n } from "@/hooks/useI18n";

export default function NotFound() {
  const router = useRouter();
  const { t } = useI18n();

  const handleGoHome = () => {
    router.push('/dashboard');
  };

  const handleGoBack = () => {
    router.back();
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[hsl(var(--color-background))] to-[hsl(var(--sidebar-background))]/5">
      <div className="max-w-md w-full mx-auto text-center px-6">
        {/* Snapland Logo */}
        <div className="mb-8 flex justify-center">
          <div className="relative">
            <Image
              src="/snapland-logo.svg"
              alt="Snapland Logo"
              width={120}
              height={40}
              className="opacity-90"
            />
          </div>
        </div>

        {/* 404 Number */}
        <div className="mb-8">
          <h1 className="text-9xl font-bold text-[hsl(var(--sidebar-primary))]">
            404
          </h1>
        </div>

        {/* Error Message */}
        <div className="mb-8">
          <h2 className="text-3xl font-semibold text-[hsl(var(--color-foreground))] mb-4">
            {t('notFound.title')}
          </h2>
          <p className="text-[hsl(var(--color-foreground))] text-lg">
            {t('notFound.description')}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
        <Button
            onClick={handleGoBack}
            variant="outline"
            size="lg"
            className="flex items-center gap-2 border-[hsl(var(--sidebar-primary))] text-[hsl(var(--sidebar-primary))] hover:bg-[hsl(var(--sidebar-primary))] hover:text-white"
          >
            <ArrowLeft className="w-4 h-4" />
            {t('notFound.goBack')}
          </Button>

          <Button
            onClick={handleGoHome}
            size="lg"
            className="flex items-center gap-2 bg-[hsl(var(--sidebar-primary))] hover:bg-[hsl(var(--sidebar-accent))] text-white"
          >
            <Home className="w-4 h-4" />
            {t('notFound.goToDashboard')}
          </Button>
          
         
        </div>

        {/* Additional Help */}
        <div className="mt-12 text-sm text-[hsl(var(--color-foreground))]">
          <p>
            {t('notFound.helpText')}
          </p>
        </div>
      </div>
    </div>
  );
}
